import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-background-50 py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20character%20silhouettes%20in%20warm%20golden%20light%2C%20soft%20atmospheric%20composition%2C%20dreamy%20bokeh%20background%2C%20elegant%20floating%20elements%2C%20gentle%20pastel%20tones%2C%20cinematic%20shallow%20depth%20of%20field%2C%20artistic%20illustration%20style%2C%20warm%20ambient%20glow%2C%20decorative%20banner%20design&width=1920&height=600&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-30"
          loading="lazy"
        />
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          {t('home:ctaSection.title', '开启你的韩漫阅读之旅')}
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
          {t('home:ctaSection.subtitle', '加入数百万读者的行列，享受极致阅读体验')}
        </p>
        <Link
          to="/category/all"
          className="whitespace-nowrap inline-flex items-center mt-8 bg-primary-500 hover:bg-primary-600 text-white rounded-full px-8 py-3.5 text-sm md:text-base font-medium transition-all duration-300 cursor-pointer hover:scale-105"
        >
          {t('home:ctaSection.button', '立即免费阅读')}
          <i className="ri-arrow-right-line ml-2"></i>
        </Link>
      </div>
    </section>
  );
}